import { connect } from 'react-redux';
import { updateVastForInspect } from '../../../actions';
import VastForm from '../../../components/sections/vastInspector/VastForm';

const mapStateToProps = state => {
  return {
    valueOfArea: state.vastSource,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onBlurArea: data => {
      dispatch(updateVastForInspect(data));
    },
  };
};

const VastFormRedux = connect(mapStateToProps, mapDispatchToProps)(VastForm);

export default VastFormRedux;
